/*
 * urgency.js — helper condiviso per l'urgency indicator delle pratiche.
 *
 * Regole (giorni interi trascorsi da submitted_at):
 *   0-1  →  verde   ("nuovo / 1 giorno")
 *   2-3  →  giallo  ("2-3 giorni")
 *    4   →  arancio ("4 giorni")
 *   5+   →  rosso   ("5+ giorni")
 *
 * L'urgency si applica solo agli stati "in attesa":
 *   inviata, in_verifica, documenti_mancanti
 * Gli stati bozza/approvata/attestazione_inviata/respinta NON hanno urgency.
 */

export const PENDING_STATUSES = new Set([
  "inviata",
  "in_verifica",
  "documenti_mancanti",
]);

const DAY_MS = 24 * 60 * 60 * 1000;

/**
 * @param {string|Date|null|undefined} submittedAt
 * @param {string} status
 * @returns {null | { days: number, level: 'green'|'yellow'|'orange'|'red',
 *   dotClass: string, pillClass: string,
 *   label: string, tooltip: string }}
 */
export function getUrgency(submittedAt, status) {
  if (!submittedAt || !PENDING_STATUSES.has(status)) return null;
  const ts = new Date(submittedAt).getTime();
  if (isNaN(ts)) return null;
  const days = Math.max(0, Math.floor((Date.now() - ts) / DAY_MS));

  let level, dotClass, pillClass, label;
  if (days <= 1) {
    level = "green";
    dotClass = "bg-emerald-500";
    pillClass = "bg-emerald-50 text-emerald-800 border-emerald-200";
    label = days === 0 ? "Oggi" : "1 giorno";
  } else if (days <= 3) {
    level = "yellow";
    dotClass = "bg-yellow-400";
    pillClass = "bg-yellow-50 text-yellow-800 border-yellow-300";
    label = `${days} giorni`;
  } else if (days === 4) {
    level = "orange";
    dotClass = "bg-orange-500";
    pillClass = "bg-orange-50 text-orange-800 border-orange-300";
    label = "4 giorni";
  } else {
    level = "red";
    dotClass = "bg-red-500";
    pillClass = "bg-red-50 text-red-800 border-red-300 font-semibold";
    label = `${days} giorni`;
  }

  const tooltip = `In attesa da ${days === 0 ? "meno di 1 giorno" : days === 1 ? "1 giorno" : days + " giorni"}`;
  return { days, level, dotClass, pillClass, label, tooltip };
}
